var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAjouter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M379.72,33.88H120.34c-47.74,0-86.46,38.72-86.46,86.46v259.33c0,47.79,38.72,86.46,86.46,86.46h259.38 c47.74,0,86.41-38.67,86.41-86.46V120.34C466.12,72.6,427.46,33.88,379.72,33.88z M381.38,275.75H267.59v113.74 c0,11.92-9.67,21.59-21.59,21.59c-11.98,0-21.64-9.67-21.64-21.59V275.75H110.67c-11.92,0-21.59-9.67-21.59-21.64 c0-11.92,9.67-21.59,21.59-21.59h113.69V118.83c0-11.98,9.67-21.64,21.64-21.64c11.92,0,21.59,9.67,21.59,21.64v113.69h113.79 c11.92,0,21.59,9.67,21.59,21.59C402.97,266.08,393.3,275.75,381.38,275.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjouter);
export default __webpack_public_path__ + "static/media/ajouter.d0d61541a9c51543698a0c82e3aa35e1.svg";
export { ForwardRef as ReactComponent };